













































import { computed, defineComponent, useRouter } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { url } from '~/utils/url';
import { CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppRectButton,
  },
  props: {
    pageNum: {
      type: Number,
      required: true,
    },
    lessonId: {
      type: Number,
      required: true,
    },
    articlePage: {
      type: Number,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();

    const transitionPage = (page: number) => {
      if (page === -1 && props.articlePage <= 1) {
        router.push(
          url(props.contentType === CollegeLessonType.AREA ? 'COLLEGE_PRODUCING_AREA_DETAIL' : 'COLLEGE_BASIC_DETAIL', {
            id: props.lessonId,
          })
        );
      } else {
        router.push(
          url(
            props.contentType === CollegeLessonType.AREA ? 'COLLEGE_PRODUCING_AREA_ARTICLE' : 'COLLEGE_BASIC_ARTICLE',
            {
              id: props.lessonId,
              page: props.articlePage + page,
            }
          )
        );
      }
    };
    const { isEnotecaAppWebView } = useEnotecaApp();
    const tag = computed(() => (isEnotecaAppWebView.value ? 'a' : undefined));

    return { transitionPage, url, CollegeLessonType, tag };
  },
});
